import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row gy-5 g-xl-1 report-container" }
const _hoisted_2 = { class: "col-xxl-12" }
const _hoisted_3 = { class: "mb-xl-1 mx-auto" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "pagebreak" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverallResult = _resolveComponent("OverallResult")!
  const _component_IndicatorsDetail = _resolveComponent("IndicatorsDetail")!
  const _component_CompareResult = _resolveComponent("CompareResult")!
  const _component_GenerationMix = _resolveComponent("GenerationMix")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_OverallResult),
        _createVNode(_component_IndicatorsDetail),
        _hoisted_4,
        _createVNode(_component_CompareResult),
        _createVNode(_component_GenerationMix)
      ])
    ])
  ]))
}